export default __webpack_public_path__ + "static/media/placeholder_dummy2016-personal01-de.ddbcf37e.png";